function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, ref, computed, watch, nextTick, getCurrentInstance } from "vue";
import { getCampaignSets, getAdAccountSearch, getCreativeSets, getUserFolders } from "@pt/api/user/index";
import { Mintegral, Unity, Applovin, IronSource, Xmp } from "./shared";
import shortid from "shortid";
import { channelList } from "@com/utils/channel";
import AuthDialog from "@pt/views/pt-entry/common-setting/account-auth/auth-dialog/index.vue";
import { cloneDeep } from "lodash-es";
import { definePropType } from "@types-vue/props";
import { PtBusinessType } from "@pt/components/common-push-dialog/config";
import { PlatformType, xmpPlatformList } from "@pt/views/pt-entry/common-setting/account-auth/config";
import { t } from "@/lang";
export default defineComponent({
    name: "ChannelSetting",
    components: {
        AuthDialog: AuthDialog
    },
    props: {
        allowedChannels: definePropType(Array),
        apps: definePropType([
            Promise,
            Object
        ]),
        business: {
            type: definePropType(String),
            required: true
        }
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var handleChannelChange = function handleChannelChange(node) {
            currentChannel.value = node.value;
            nextTick(function() {
                if (leftPanelRef.value) {
                    // 需求：选择Xmp平台后，横向滚动条自动滑到打包渠道
                    if (node.value === Xmp && props.business !== PtBusinessType.Video && channelPanelRef.value) {
                        leftPanelRef.value.scrollLeft = channelPanelRef.value.scrollWidth - 78;
                    } else {
                        // 需求：选择平台后，横向滚动条自动滑到最右侧
                        leftPanelRef.value.scrollLeft = leftPanelRef.value.scrollWidth;
                    }
                }
            });
        };
        var getXmpPushChannelIds = function getXmpPushChannelIds(result) {
            xmpPushChannelIds.value = result;
            emit("xmpChannelIds", xmpPushChannelIds.value);
        };
        var handleNodeExpand = function handleNodeExpand(node, expended, level) {
            var // 节点展开时，清空下级节点的 searchValue
            _$ref;
            (_$ref = panelConfigs.value) === null || _$ref === void 0 ? void 0 : _$ref.forEach(function(config, index) {
                if (index > level) {
                    config.searchValue = "";
                    config.activeValue = "";
                } else if (index === level) {
                    config.activeValue = expended ? node.value : "";
                }
            });
        };
        var handleSearch = function handleSearch(level) {
            var // 搜索时，清空上级节点的 activeValue
            _$ref;
            (_$ref = panelConfigs.value) === null || _$ref === void 0 ? void 0 : _$ref.forEach(function(config, index) {
                var c = panelConfigs.value[index];
                if (c && index !== 0 && index < level) {
                    c.activeValue = "";
                }
            });
        };
        var fetchData = function fetchData() {
            loading.value = true;
            var _apps;
            Promise.all([
                getAdAccountSearch({
                    traffic_types: [
                        Mintegral,
                        Unity,
                        IronSource,
                        Applovin
                    ]
                }),
                Promise.resolve((_apps = props.apps) !== null && _apps !== void 0 ? _apps : getCampaignSets().then(function(campaignSetsRes) {
                    return campaignSetsRes.data.data.list || {};
                })),
                getCreativeSets().then(function(creativeSetsRes) {
                    return creativeSetsRes.data.data.list || {};
                }),
                getUserFolders().then(function(userFolders) {
                    return userFolders.data.data || {};
                }), 
            ]).then(function(param) {
                var _param = _slicedToArray(param, 4), adListRes = _param[0], campaignSets = _param[1], creativeSets = _param[2], userFolders = _param[3];
                var _Mintegral, _Unity, _IronSource, _Applovin, _xmp;
                var _data = [
                    {
                        label: "Mintegral",
                        value: Mintegral,
                        children: transformData((_Mintegral = adListRes.data.data.list[Mintegral]) !== null && _Mintegral !== void 0 ? _Mintegral : [])
                    },
                    {
                        label: "Unity",
                        value: Unity,
                        children: transformData((_Unity = adListRes.data.data.list[Unity]) !== null && _Unity !== void 0 ? _Unity : []).map(function(node) {
                            var list = campaignSets[node.value];
                            var children = list === null || list === void 0 ? void 0 : list.map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.app_name,
                                    value: item.app_id
                                });
                            });
                            return _objectSpreadProps(_objectSpread({}, node), {
                                children: children
                            });
                        })
                    },
                    {
                        label: "IronSource",
                        value: IronSource,
                        children: transformData((_IronSource = adListRes.data.data.list[IronSource]) !== null && _IronSource !== void 0 ? _IronSource : []).map(function(node) {
                            var list = campaignSets[node.value];
                            var children = list === null || list === void 0 ? void 0 : list.map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.app_name,
                                    value: item.app_id
                                });
                            });
                            return _objectSpreadProps(_objectSpread({}, node), {
                                children: children
                            });
                        })
                    },
                    {
                        label: "Applovin",
                        value: Applovin,
                        tooltip: t("playTurbo.pushDialog.channel.applovinTooltip"),
                        children: transformData((_Applovin = adListRes.data.data.list[Applovin]) !== null && _Applovin !== void 0 ? _Applovin : []).map(function(node) {
                            var list = creativeSets[node.value];
                            var children = list === null || list === void 0 ? void 0 : list.map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.name,
                                    value: item.id,
                                    package_name: item.id
                                });
                            });
                            return _objectSpreadProps(_objectSpread({}, node), {
                                children: children
                            });
                        })
                    },
                    {
                        label: "Xmp",
                        value: Xmp,
                        excessChildren: [],
                        children: ((_xmp = adListRes.data.data.xmp) !== null && _xmp !== void 0 ? _xmp : []).map(function(item) {
                            return {
                                label: item.account_name,
                                value: item.id,
                                xmp_user_id: item.xmp_user_id
                            };
                        }).map(function(node) {
                            // @ts-ignore
                            var list = userFolders[node.xmp_user_id];
                            var children = list === null || list === void 0 ? void 0 : list.map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.folder_name,
                                    value: item.folder_id,
                                    package_name: String(item.folder_id)
                                });
                            });
                            return _objectSpreadProps(_objectSpread({}, node), {
                                children: children
                            });
                        })
                    }, 
                ];
                var resolveCampaignMap = function(nodes, parentNode) {
                    return nodes.map(function(node) {
                        var value = shortid.generate();
                        nodeValueMap.set(value, {
                            id: node.value,
                            pid: parentNode === null || parentNode === void 0 ? void 0 : parentNode.value
                        });
                        node.value = value;
                        return _objectSpreadProps(_objectSpread({}, node), {
                            value: value,
                            children: node.children ? resolveCampaignMap(node.children, node) : undefined
                        });
                    });
                };
                // 清空数据
                nodeValueMap.clear();
                data1.value = _data.filter(function(node) {
                    return allowedChannelsPlatform.value ? allowedChannelsPlatform.value.includes(node.value) : true;
                }).map(function(node) {
                    var v = _objectSpreadProps(_objectSpread({}, node), {
                        children: node.children ? resolveCampaignMap(node.children, node) : undefined
                    });
                    return v;
                });
            }).finally(function() {
                loading.value = false;
            });
        };
        var transformData = function transformData(data) {
            return data.map(function(item) {
                var _$ref;
                return {
                    label: item.account_name,
                    value: item.id,
                    children: (_$ref = item.sub_accounts) === null || _$ref === void 0 ? void 0 : _$ref.map(function(child) {
                        return {
                            label: child.account_name,
                            value: child.id
                        };
                    })
                };
            });
        };
        var removeNode = function removeNode(v) {
            if (xmpPushChannelIds.value.length) {
                var index = xmpPushChannelIds.value.findIndex(function(s) {
                    return s === v;
                });
                if (index !== -1) xmpPushChannelIds.value.splice(index, 1);
            }
            var values = Array.isArray(v) ? v : [
                v
            ];
            panelConfigs.value = panelConfigs.value.map(function(config) {
                var copyConfig = cloneDeep(config);
                Object.values(copyConfig.channels).forEach(function(channel) {
                    channel.values = channel.values.filter(function(item) {
                        return !values.includes(item);
                    });
                });
                return copyConfig;
            });
        };
        var clearSelected = function clearSelected() {
            panelConfigs.value.forEach(function(config) {
                Object.values(config.channels).forEach(function(channel) {
                    channel.values = [];
                });
            });
            xmpPushChannelIds.value = [];
            emit("xmpChannelIds", xmpPushChannelIds.value);
        };
        var isCheckAll = function isCheckAll(nodes, values) {
            if (nodes.length === 0) {
                return false;
            }
            return nodes.every(function(node) {
                return values.includes(node.value);
            });
        };
        var toggleCheckAll = function toggleCheckAll(nodes, values, options) {
            var action = options.action, _clearChildren = options.clearChildren, clearChildren = _clearChildren === void 0 ? true : _clearChildren;
            if (nodes.length === 0) {
                return;
            }
            // 目前是否全选
            var isAll = isCheckAll(nodes, values);
            // 目前不是全选 并且要全选时候
            var selectedAll = !isAll && !action;
            var nodesValue = nodes.map(function(node) {
                return node.value;
            });
            var removeCheckedNodes = function(currCheckedValues) {
                var _children;
                removeNode(_toConsumableArray(currCheckedValues).concat(// children
                _toConsumableArray(clearChildren ? nodes.filter(function(v) {
                    return currCheckedValues.includes(v.value);
                }).map(function(node) {
                    return (_children = node.children) !== null && _children !== void 0 ? _children : [];
                }).flat(1).map(function(v) {
                    return v.value;
                }) : [])));
            };
            // 全选
            if (selectedAll || action === "all") {
                var _values;
                (_values = values).push.apply(_values, _toConsumableArray(nodesValue.filter(function(v) {
                    return !values.includes(v);
                })));
            } else if (action === "reverse") {
                var _values1;
                var oldValues = _toConsumableArray(values);
                var willBeCheckedValues = nodesValue.filter(function(v) {
                    return !values.includes(v);
                });
                (_values1 = values).push.apply(_values1, _toConsumableArray(willBeCheckedValues));
                var currCheckedValues2 = nodesValue.filter(function(v) {
                    return oldValues.includes(v);
                });
                nextTick(function() {
                    removeCheckedNodes(currCheckedValues2);
                });
            } else {
                // 清空
                var currCheckedValues1 = nodesValue.filter(function(v) {
                    return values.includes(v);
                });
                removeCheckedNodes(currCheckedValues1);
            }
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var leftPanelRef = ref();
        var channelPanelRef = ref();
        var authDialogVisible = ref(false);
        var xmpPushChannelIds = ref([]);
        // 产品id，单个产品会对应多个账号，故在树形结构中，要抹除这种可能性，所以针对产品生成唯一的id，并缓存对应的真实产品id
        var nodeValueMap = new Map();
        var loading = ref(false);
        var currentChannel = ref();
        var _obj, _obj1, _obj2;
        var panelConfigs = ref([
            {
                activeValue: "",
                searchValue: "",
                channels: (_obj = {}, _defineProperty(_obj, Mintegral, {
                    title: root.$t("playTurbo.pushDialog.channel.title"),
                    values: []
                }), _defineProperty(_obj, Unity, {
                    title: root.$t("playTurbo.pushDialog.channel.title"),
                    values: []
                }), _defineProperty(_obj, Applovin, {
                    title: root.$t("playTurbo.pushDialog.channel.title"),
                    values: []
                }), _defineProperty(_obj, IronSource, {
                    title: root.$t("playTurbo.pushDialog.channel.title"),
                    values: []
                }), _defineProperty(_obj, Xmp, {
                    title: root.$t("playTurbo.pushDialog.channel.title"),
                    values: []
                }), _obj)
            },
            {
                activeValue: "",
                searchValue: "",
                channels: (_obj1 = {}, _defineProperty(_obj1, Mintegral, {
                    title: root.$t("playTurbo.pushDialog.channel.accountMain"),
                    values: [],
                    selectable: true
                }), _defineProperty(_obj1, Unity, {
                    title: root.$t("playTurbo.pushDialog.channel.account"),
                    values: []
                }), _defineProperty(_obj1, Applovin, {
                    title: root.$t("playTurbo.pushDialog.channel.account"),
                    values: []
                }), _defineProperty(_obj1, IronSource, {
                    title: root.$t("playTurbo.pushDialog.channel.account"),
                    values: []
                }), _defineProperty(_obj1, Xmp, {
                    title: root.$t("playTurbo.pushDialog.channel.account"),
                    values: []
                }), _obj1)
            },
            {
                activeValue: "",
                searchValue: "",
                channels: (_obj2 = {}, _defineProperty(_obj2, Mintegral, {
                    title: root.$t("playTurbo.pushDialog.channel.accountChild"),
                    values: [],
                    selectable: true
                }), _defineProperty(_obj2, Unity, {
                    title: root.$t("playTurbo.pushDialog.channel.product"),
                    values: [],
                    selectable: true
                }), _defineProperty(_obj2, Applovin, {
                    title: root.$t("playTurbo.pushDialog.channel.creativeSet"),
                    values: [],
                    selectable: true
                }), _defineProperty(_obj2, IronSource, {
                    title: root.$t("playTurbo.pushDialog.channel.product"),
                    values: [],
                    selectable: true
                }), _defineProperty(_obj2, Xmp, {
                    title: root.$t("playTurbo.assetLibrary.asset.details.folder"),
                    values: [],
                    selectable: true
                }), _obj2)
            }, 
        ]);
        var data1 = ref([]);
        var getValues = function(channel) {
            var panelConfigsValues = panelConfigs.value.reduce(function(result, next) {
                var _result;
                (_result = result).push.apply(_result, _toConsumableArray(next.channels[channel].values));
                return result;
            }, []);
            if (channel === Xmp && xmpPushChannelIds.value.length) {
                panelConfigsValues = _toConsumableArray(panelConfigsValues).concat(_toConsumableArray(xmpPushChannelIds.value));
            }
            return panelConfigsValues.map(function(v) {
                return {
                    label: String(v),
                    value: v
                };
            });
        };
        var needCheckSize = function(value) {
            // 如果一级是平台的话不展示包体信息
            return channelList.some(function(x) {
                return x.value === value;
            });
        };
        var xmpPushChannels = computed(function() {
            // xmp支持的打包渠道(受套餐限制)
            return xmpPlatformList().filter(function(x) {
                return props.allowedChannels && props.allowedChannels.includes(x.value);
            });
        });
        var displayValues = computed(function() {
            var _$ref11, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
            var values = panelConfigs.value.reduce(function(result, next) {
                var _result, _result1, _result2, _result3, _result4;
                (_result = result).push.apply(_result, _toConsumableArray(next.channels[Mintegral].values));
                (_result1 = result).push.apply(_result1, _toConsumableArray(next.channels[Unity].values));
                (_result2 = result).push.apply(_result2, _toConsumableArray(next.channels[Applovin].values));
                (_result3 = result).push.apply(_result3, _toConsumableArray(next.channels[IronSource].values));
                (_result4 = result).push.apply(_result4, _toConsumableArray(next.channels[Xmp].values));
                return result;
            }, []);
            var _$ref6;
            // Unity 根据产品找到对应的账号
            var UnityCampaignValues = (_$ref6 = (_$ref11 = panelConfigs.value[2]) === null || _$ref11 === void 0 ? void 0 : _$ref11.channels[Unity].values.map(function(v) {
                var _$ref;
                return (_$ref = findParentNode(data1.value, v)) === null || _$ref === void 0 ? void 0 : _$ref.value;
            }).filter(function(v) {
                return Boolean(v);
            })) !== null && _$ref6 !== void 0 ? _$ref6 : [];
            var _$ref7;
            // IronSource 根据产品找到对应的账号
            var IronSourceCampaignValues = (_$ref7 = (_$ref1 = panelConfigs.value[2]) === null || _$ref1 === void 0 ? void 0 : _$ref1.channels[IronSource].values.map(function(v) {
                var _$ref;
                return (_$ref = findParentNode(data1.value, v)) === null || _$ref === void 0 ? void 0 : _$ref.value;
            }).filter(function(v) {
                return Boolean(v);
            })) !== null && _$ref7 !== void 0 ? _$ref7 : [];
            var _$ref8;
            var ApplovinCreativeSetValues = (_$ref8 = (_$ref2 = panelConfigs.value[2]) === null || _$ref2 === void 0 ? void 0 : _$ref2.channels[Applovin].values.map(function(v) {
                var _$ref;
                return (_$ref = findParentNode(data1.value, v)) === null || _$ref === void 0 ? void 0 : _$ref.value;
            }).filter(function(v) {
                return Boolean(v);
            })) !== null && _$ref8 !== void 0 ? _$ref8 : [];
            var _$ref9;
            // Xmp 根据文件夹找到对应的账号
            var XmpCreativeSetValues = (_$ref9 = (_$ref3 = panelConfigs.value[2]) === null || _$ref3 === void 0 ? void 0 : _$ref3.channels[Xmp].values.map(function(v) {
                var _$ref;
                return (_$ref = findParentNode(data1.value, v)) === null || _$ref === void 0 ? void 0 : _$ref.value;
            }).filter(function(v) {
                return Boolean(v);
            })) !== null && _$ref9 !== void 0 ? _$ref9 : [];
            var allSelectedValues = Array.from(new Set(_toConsumableArray(UnityCampaignValues).concat(_toConsumableArray(IronSourceCampaignValues), _toConsumableArray(ApplovinCreativeSetValues), _toConsumableArray(XmpCreativeSetValues), _toConsumableArray(xmpPushChannelIds.value), _toConsumableArray(values), _toConsumableArray(data1.value.map(function(v) {
                return v.value;
            })))));
            (_$ref4 = data1.value) === null || _$ref4 === void 0 ? void 0 : _$ref4.map(function(s1) {
                if (s1.value === Xmp) {
                    // @ts-ignore
                    s1.excessChildren = xmpPushChannels.value.filter(function(s) {
                        return xmpPushChannelIds.value.includes(s.value);
                    });
                }
            });
            var filter = function(source) {
                return source === null || source === void 0 ? void 0 : source.filter(function(node) {
                    return allSelectedValues.includes(node.value);
                }).map(function(node) {
                    if (XmpCreativeSetValues.length && node && node.excessChildren) {
                        return _objectSpreadProps(_objectSpread({}, node), {
                            children: filter(_toConsumableArray(node.children).concat(_toConsumableArray(node.excessChildren)))
                        });
                    } else if (xmpPushChannelIds.value.length) {
                        return _objectSpreadProps(_objectSpread({}, node), {
                            children: filter(node.excessChildren) || filter(node.children)
                        });
                    }
                    return _objectSpreadProps(_objectSpread({}, node), {
                        children: filter(node.children)
                    });
                });
            };
            var _$ref10;
            return (_$ref10 = (_$ref5 = filter(data1.value)) === null || _$ref5 === void 0 ? void 0 : _$ref5.filter(function(item) {
                return item.children && item.children.length > 0;
            })) !== null && _$ref10 !== void 0 ? _$ref10 : [];
        });
        var selected = computed(function() {
            var channels = [
                {
                    name: "Mintegral",
                    id: Mintegral
                },
                {
                    name: "Unity",
                    id: Unity
                },
                {
                    name: "Applovin",
                    id: Applovin
                },
                {
                    name: "IronSource",
                    id: IronSource
                },
                {
                    name: "Xmp",
                    id: Xmp
                }, 
            ];
            return channels.reduce(function(result, channel) {
                // @ts-ignore
                var values = getValues(channel.id);
                if (values.length) {
                    result.push({
                        name: channel.name,
                        id: channel.id,
                        values: values
                    });
                }
                return result;
            }, []);
        });
        var allowedChannelsPlatform = computed(function() {
            return Array.isArray(props.allowedChannels) ? _toConsumableArray(props.allowedChannels).concat([
                PlatformType.Xmp
            ]) : [
                PlatformType.Xmp
            ];
        });
        watch([
            function() {
                return authDialogVisible.value;
            },
            function() {
                return allowedChannelsPlatform.value;
            },
            function() {
                return props.apps;
            }, 
        ], function() {
            if (!authDialogVisible.value && (!allowedChannelsPlatform.value || allowedChannelsPlatform.value.length > 0)) {
                fetchData();
            }
        }, {
            deep: true,
            immediate: true
        });
        watch(function() {
            return displayValues.value;
        }, function() {
            var traverse = function(node, cb) {
                var _node = cb(node);
                if (_node.children) {
                    _node.children = _node.children.map(function(child) {
                        return traverse(child, cb);
                    });
                }
                return _node;
            };
            emit("change", displayValues.value.map(function(n) {
                var _$ref12;
                return _objectSpreadProps(_objectSpread({}, n), {
                    children: (_$ref12 = n.children) === null || _$ref12 === void 0 ? void 0 : _$ref12.map(function(child) {
                        return traverse(child, function(node) {
                            var v = nodeValueMap.get(node.value);
                            var _$ref;
                            return _objectSpreadProps(_objectSpread({}, node), {
                                value: (_$ref = v === null || v === void 0 ? void 0 : v.id) !== null && _$ref !== void 0 ? _$ref : node.value
                            });
                        });
                    })
                });
            }));
        }, {
            deep: true
        });
        // 取消时候，清空下级
        watch(function() {
            var _$ref;
            return (_$ref = panelConfigs.value[1]) === null || _$ref === void 0 ? void 0 : _$ref.channels[Mintegral].values;
        }, function(newValues, oldValues) {
            var _newValues = newValues !== null && newValues !== void 0 ? newValues : [];
            var _oldValues = oldValues !== null && oldValues !== void 0 ? oldValues : [];
            // // 找到取消的值
            var removedValues = _oldValues.filter(function(v) {
                return !_newValues.includes(v);
            });
            // 清空下级
            removedValues.forEach(function(v) {
                var _$ref, _$ref13;
                var nodes = data1.value.reduce(function(result, node) {
                    var _result;
                    var _children;
                    (_result = result).push.apply(_result, _toConsumableArray((_children = node.children) !== null && _children !== void 0 ? _children : []));
                    return result;
                }, []);
                var children = (_$ref = findNode(nodes, v)) === null || _$ref === void 0 ? void 0 : _$ref.children;
                var channel = (_$ref13 = panelConfigs.value[2]) === null || _$ref13 === void 0 ? void 0 : _$ref13.channels[Mintegral];
                if (children && children.length && channel) {
                    channel.values = channel.values.filter(function(vid) {
                        return !children.some(function(child) {
                            return child.value === vid;
                        });
                    });
                }
            });
        }, {
            deep: true
        });
        var _values2;
        // 选中时候，选中上级
        watch(function() {
            var _$ref;
            return (_values2 = (_$ref = panelConfigs.value[2]) === null || _$ref === void 0 ? void 0 : _$ref.channels[Mintegral].values) !== null && _values2 !== void 0 ? _values2 : [];
        }, function(newValues) {
            var _$ref;
            var _newValues = newValues !== null && newValues !== void 0 ? newValues : [];
            var channel = (_$ref = panelConfigs.value[1]) === null || _$ref === void 0 ? void 0 : _$ref.channels[Mintegral];
            var nodes = data1.value.reduce(function(result, node) {
                var _result;
                var _children;
                (_result = result).push.apply(_result, _toConsumableArray((_children = node.children) !== null && _children !== void 0 ? _children : []));
                return result;
            }, []);
            _newValues.forEach(function(v) {
                var parent = findParentNode(nodes, v);
                if (channel && parent && !channel.values.includes(parent.value)) {
                    channel.values.push(parent.value);
                }
            });
        }, {
            deep: true
        });
        function findNode(nodes, value) {
            return nodes.find(function(node) {
                if (node.value === value) {
                    return true;
                } else if (node.children) {
                    return findNode(node.children, value);
                }
            });
        }
        function findParentNode(nodes, value, parentNode) {
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ((node === null || node === void 0 ? void 0 : node.value) === value) {
                    return parentNode;
                } else if ((node === null || node === void 0 ? void 0 : node.children) && (node === null || node === void 0 ? void 0 : node.children.length) > 0) {
                    var n = findParentNode(node.children, value, node);
                    if (n) {
                        return n;
                    }
                }
            }
        }
        function getNodes(query, level) {
            var _$ref, _$ref14, _$ref15, _$ref16;
            var _$ref17;
            // 获取上一级的 searchValue
            var parentSearchValue = (_$ref17 = (_$ref = panelConfigs.value) === null || _$ref === void 0 ? void 0 : (_$ref14 = _$ref[level - 1]) === null || _$ref14 === void 0 ? void 0 : _$ref14.searchValue) !== null && _$ref17 !== void 0 ? _$ref17 : "";
            var parentActiveValue = (_$ref15 = panelConfigs.value) === null || _$ref15 === void 0 ? void 0 : (_$ref16 = _$ref15[level - 1]) === null || _$ref16 === void 0 ? void 0 : _$ref16.activeValue;
            var allData = level === 0 ? data1.value.filter(function(node) {
                return !currentChannel.value || node.value === currentChannel.value;
            }) : getNodes(parentSearchValue, level - 1).filter(function(node) {
                return parentActiveValue ? node.value === parentActiveValue : true;
            }).reduce(function(result, next) {
                var _result;
                var _children;
                (_result = result).push.apply(_result, _toConsumableArray((_children = next.children) !== null && _children !== void 0 ? _children : []));
                return result;
            }, []);
            return allData.filter(function(node) {
                return node.label.toString().toLowerCase().includes(query.toLowerCase()) || (node.package_name ? node.package_name.toString().toLowerCase().includes(query.toLowerCase()) : false);
            });
        }
        return {
            leftPanelRef: leftPanelRef,
            channelPanelRef: channelPanelRef,
            authDialogVisible: authDialogVisible,
            Mintegral: Mintegral,
            Unity: Unity,
            Applovin: Applovin,
            IronSource: IronSource,
            Xmp: Xmp,
            loading: loading,
            displayValues: displayValues,
            selected: selected,
            data: data1,
            needCheckSize: needCheckSize,
            currentChannel: currentChannel,
            panelConfigs: panelConfigs,
            xmpPushChannels: xmpPushChannels,
            xmpPushChannelIds: xmpPushChannelIds,
            getNodes: getNodes,
            handleChannelChange: handleChannelChange,
            getXmpPushChannelIds: getXmpPushChannelIds,
            handleNodeExpand: handleNodeExpand,
            handleSearch: handleSearch,
            removeNode: removeNode,
            clearSelected: clearSelected,
            isCheckAll: isCheckAll,
            toggleCheckAll: toggleCheckAll,
            PtBusinessType: PtBusinessType
        };
    }
});
